import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InputTextConfig } from '@core/models/built/procedure-step-config.model';
import { InputJson } from '@core/models/built/session-step-value-json.model';
import { SessionStepValueType } from '@core/models/built/session-step-value-type.enum';
import { SessionStep, SessionStepValue } from '@core/models/session.model';

import { filterTruthy } from '@utils';
import { DateTime } from 'luxon';
import { BehaviorSubject } from 'rxjs';
import { first, map } from 'rxjs/operators';

@Component({
  templateUrl: './input-text-session.component.html'
})
export class InputTextSessionComponent implements OnChanges {

  @Input() step?: SessionStep;

  @Output() commitAndNext = new EventEmitter<SessionStep>();

  private step$$ = new BehaviorSubject<SessionStep | undefined>(undefined);
  step$ = this.step$$.pipe(filterTruthy());

  rows$ = this.step$.pipe(
    map(step => (step.procedureStep?.config as InputTextConfig).rows || 1)
  );

  inputForm: FormGroup = this.fb.group({
    value: ['', [Validators.required]]
  });

  constructor(
    private fb: FormBuilder
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.step) {
      this.step$$.next(changes.step.currentValue);
    }
  }

  submit() {
    if (this.inputForm.valid) {
      this.step$.pipe(first()).subscribe(step => {
        const now = DateTime.local();
        const value: SessionStepValue = {
          workflowId: step.workflowId,
          workflowStepId: step.workflowStepId,
          sessionId: step.sessionId,
          timestamp: now.toJSDate(),
          type: SessionStepValueType.inputString,
          value: { input: this.inputForm.value.value.trim() } as InputJson
        };
        this.commitAndNext.emit({ ...step, completedOn: now.toJSDate(), values: [value] });
      });
    }
  }

}
